import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { key: 0 };
import { validationRules } from "@/ValidationRules";
import Customer from "@/model/Customer.model";
import { inject, onMounted, reactive, ref } from "vue";
import { useMessageStore } from "@/stores/MessageStore";
import OrderList from "@/components/admin/OrderList.vue";
import Order from "@/model/Order.model";
import { CustomerServiceSymbol, OrderServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EditCustomerView',
    props: {
        id: {
            type: String,
            required: false
        }
    },
    setup(__props) {
        const customerService = inject(CustomerServiceSymbol);
        const orderService = inject(OrderServiceSymbol);
        const messageStore = useMessageStore();
        const editCustomer = reactive(new Customer());
        const customerOrders = reactive([]);
        let saveInFlight = ref(false);
        let form = ref(null);
        const props = __props;
        onMounted(() => {
            if (props.id) {
                customerService.getCustomer(props.id)
                    .then(response => {
                    editCustomer.init(response.data);
                });
                orderService.loadOrders(props.id)
                    .then((response) => {
                    response.data.forEach(order => {
                        const typedOrder = new Order();
                        typedOrder.assign(order);
                        customerOrders.push(typedOrder);
                    });
                });
            }
        });
        function save() {
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    saveInFlight.value = true;
                    let promise;
                    if (props.id) {
                        promise = customerService.updateCustomer(editCustomer);
                    }
                    else {
                        promise = customerService.createCustomer(editCustomer);
                    }
                    promise.then(response => {
                        editCustomer.init(response.data);
                        saveInFlight.value = false;
                        messageStore.addMessage("Erfolgreich gespeichert");
                    }).catch(function () {
                        saveInFlight.value = false;
                    });
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "d-flex flex-wrap" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex justify-space-between v-col-12" }, {
                        default: _withCtx(() => [
                            (!__props.id && !editCustomer.id)
                                ? (_openBlock(), _createBlock(_component_v_container, {
                                    key: 0,
                                    class: "text-h4 text-start ma-0 pa-0"
                                }, {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                        _createTextVNode(" Neuen Kunden anlegen ")
                                    ])),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            (__props.id || editCustomer.id)
                                ? (_openBlock(), _createBlock(_component_v_container, {
                                    key: 1,
                                    class: "text-h4 text-start ma-0 pa-0"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(editCustomer.firstname) + " " + _toDisplayString(editCustomer.lastname), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createVNode(_component_v_btn, { onClick: save }, {
                                default: _withCtx(() => [
                                    (!_unref(saveInFlight))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Speichern"))
                                        : _createCommentVNode("", true),
                                    (_unref(saveInFlight))
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 1,
                                            indeterminate: true
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_card, { class: "mx-3 mt-0 mb-2 d-flex" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_form, {
                                ref_key: "form",
                                ref: form
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-12" }, {
                                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode("Kundendetails")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_container, {
                                        fluid: true,
                                        class: "d-flex flex-wrap justify-start pt-0"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-2 compact",
                                                modelValue: editCustomer.id,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((editCustomer.id) = $event)),
                                                label: "ID",
                                                disabled: true,
                                                density: "compact",
                                                variant: "outlined"
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-10 compact",
                                                modelValue: editCustomer.company,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((editCustomer.company) = $event)),
                                                label: "Firma",
                                                density: "compact",
                                                variant: "outlined",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6 compact",
                                                modelValue: editCustomer.firstname,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((editCustomer.firstname) = $event)),
                                                rules: [_unref(validationRules).required],
                                                label: "Vorname",
                                                variant: "outlined",
                                                density: "compact",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6 compact",
                                                modelValue: editCustomer.lastname,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editCustomer.lastname) = $event)),
                                                rules: [_unref(validationRules).required],
                                                label: "Nachname",
                                                variant: "outlined",
                                                density: "compact",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6 compact",
                                                modelValue: editCustomer.street,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((editCustomer.street) = $event)),
                                                rules: [_unref(validationRules).required],
                                                label: "Strasse",
                                                density: "compact",
                                                variant: "outlined",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6 compact",
                                                modelValue: editCustomer.unitNumber,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((editCustomer.unitNumber) = $event)),
                                                rules: [_unref(validationRules).required],
                                                label: "Hausnummer",
                                                variant: "outlined",
                                                density: "compact",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6 compact",
                                                modelValue: editCustomer.postcode,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((editCustomer.postcode) = $event)),
                                                rules: [_unref(validationRules).required],
                                                label: "Postleitzahl",
                                                variant: "outlined",
                                                density: "compact",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6 compact",
                                                modelValue: editCustomer.city,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((editCustomer.city) = $event)),
                                                rules: [_unref(validationRules).required],
                                                label: "Stadt",
                                                variant: "outlined",
                                                density: "compact",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6 compact",
                                                modelValue: editCustomer.phone,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((editCustomer.phone) = $event)),
                                                rules: [_unref(validationRules).phoneNumber],
                                                label: "Telefon",
                                                variant: "outlined",
                                                density: "compact",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6 compact",
                                                modelValue: editCustomer.mobile,
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((editCustomer.mobile) = $event)),
                                                rules: [_unref(validationRules).required, _unref(validationRules).phoneNumber],
                                                label: "Mobil",
                                                variant: "outlined",
                                                density: "compact",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"]),
                                            _createVNode(_component_v_text_field, {
                                                class: "v-col-6",
                                                modelValue: editCustomer.email,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((editCustomer.email) = $event)),
                                                rules: [_unref(validationRules).required],
                                                label: "Email",
                                                variant: "outlined",
                                                density: "compact",
                                                maxlength: "255",
                                                counter: ""
                                            }, null, 8, ["modelValue", "rules"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 512)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_container, { class: "v-col-12 ma-0 pa-0" }),
                    _createVNode(_component_v_card, { class: "ma-3 mt-0 d-flex flex-wrap" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-12" }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode("Buchungen")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "d-flex flex-wrap justify-start pt-0" }, {
                                default: _withCtx(() => [
                                    _createVNode(OrderList, {
                                        orders: customerOrders,
                                        class: "w-100"
                                    }, null, 8, ["orders"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
